(function(angular, module) {var ProgramModelReportController, ProgramModelReportService, programModelReportStates, resolveProgramModelData,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

programModelReportStates = function($stateProvider, TagUrl) {
  'ngInject';
  var url;
  url = new TagUrl().addTagTypes(['program', 'location']).setTagDefault('affiliation', 'all').addExtraParam('page', {
    type: 'int',
    value: 1,
    squash: true
  }).addExtraParam('sort', 'program.name');
  $stateProvider.state('reports.programModel', {
    url: url.buildUrl('/model'),
    params: url.params,
    templateUrl: 'reports/programModel/base',
    data: {
      tagUrl: url
    },
    controller: 'ProgramModelReportController',
    controllerAs: '$ctrl',
    resolve: {
      data: resolveProgramModelData
    },
    reloadOnSearch: false,
    abstract: true
  });
  return $stateProvider.state('reports.programModel.section', {
    url: '/{section}',
    reloadOnSearch: false,
    templateUrl: function($stateParams) {
      var name;
      name = $stateParams.section.replace('-', '_');
      return "reports/programModel/" + name;
    }
  });
};


/* @ngInject */

resolveProgramModelData = function(ProgramModelReportService, $stateParams) {
  return ProgramModelReportService.loadData($stateParams);
};

ProgramModelReportService = (function() {

  /* @ngInject */
  function ProgramModelReportService($http, ApiUrl) {
    this.$http = $http;
    this.ApiUrl = ApiUrl;
  }

  ProgramModelReportService.prototype.loadData = function(params) {
    var url;
    url = this.ApiUrl('reports', 'program_model');
    return this.$http.get(url, {
      params: params
    }).then(function(result) {
      return result.data;
    });
  };

  return ProgramModelReportService;

})();

ProgramModelReportController = (function() {

  /* @ngInject */
  function ProgramModelReportController($scope, $state, $timeout, $stateParams, data, ProgramModelReportService, FileService, ApiUrl) {
    this.FileService = FileService;
    this.ApiUrl = ApiUrl;
    this.setSort = bind(this.setSort, this);
    this.turnPage = bind(this.turnPage, this);
    this.reload = bind(this.reload, this);
    this.scope = $scope;
    this.state = $state;
    this.timeout = $timeout;
    this.loading = false;
    this.service = ProgramModelReportService;
    this.data = data;
    this.sort = $stateParams.sort;
    this.page = $stateParams.page;
    this.scope.$watch('$ctrl.data.page', this.turnPage);
  }

  ProgramModelReportController.prototype.reload = function() {
    this.loading = true;
    return this.service.loadData(this.state.params).then((function(_this) {
      return function(result) {
        _this.data = result;
        return _this.loading = false;
      };
    })(this));
  };

  ProgramModelReportController.prototype.triggerReload = function() {
    clearTimeout(this.timeoutId);
    return this.timeOutId = this.timeout(this.reload, 10);
  };

  ProgramModelReportController.prototype.turnPage = function(page) {
    if (page === this.page) {
      return;
    }
    this.page = page;
    this.state.go('.', {
      page: page
    }, {
      location: 'replace'
    });
    return this.triggerReload();
  };

  ProgramModelReportController.prototype.setSort = function(sort) {
    this.state.go('.', {
      page: 1,
      sort: this.sort
    }, {
      location: 'replace'
    });
    return this.triggerReload();
  };

  ProgramModelReportController.prototype.tagChange = function(tags) {
    clearTimeout(this.setTagTimepout);
    return this.setTagTimApiUrlepout = this.timeout(((function(_this) {
      return function() {
        return _this.setTags(tags);
      };
    })(this)), 10);
  };

  ProgramModelReportController.prototype.downloadFile = function() {
    var url;
    url = this.ApiUrl('reports', 'program_model', 'export.xlsx');
    this.downloading = true;
    this.FileService.downloadFile(url, this.tags).then((function(_this) {
      return function() {
        _this.downloading = false;
      };
    })(this));
  };

  ProgramModelReportController.prototype.setTags = function(tags) {
    if (!this.tags) {
      this.tags = tags;
      return;
    }
    if (!angular.equals(tags, this.tags)) {
      this.tags = tags;
      this.state.go('.', tags, {
        location: 'replace'
      });
      this.turnPage(1);
      this.triggerReload();
    }
  };

  ProgramModelReportController.prototype.months = (function() {
    var i, j, results;
    results = [];
    for (i = j = 0; j <= 11; i = ++j) {
      results.push(moment(new Date(2017, i, 1)).format('MMM'));
    }
    return results;
  })();

  ProgramModelReportController.prototype.sections = [
    {
      id: 'info',
      label: 'Program Info'
    }, {
      id: 'sponsor',
      label: "Sponsoring Org"
    }, {
      id: 'enrollment',
      label: 'Enrollment Info'
    }, {
      id: 'enrollment-dates',
      label: 'Enrollment Dates'
    }, {
      id: 'education',
      label: 'Education Practices'
    }, {
      id: 'career-pathways',
      label: 'Career Pathways'
    }, {
      id: 'design',
      label: 'Program Design'
    }, {
      id: 'pse-bridging',
      label: 'PSE Bridging Activities'
    }, {
      id: 'misc',
      label: 'Miscellaneous'
    }
  ];

  return ProgramModelReportController;

})();

module.controller('ProgramModelReportController', ProgramModelReportController);

module.config(programModelReportStates);

module.service('ProgramModelReportService', ProgramModelReportService);
})(angular, angular.module("dybReports"));